import { Link, useHistory } from "react-router-dom";

const Footer = () => {
  const history = useHistory();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      history.push("/");
      // Wait for the navigation to complete and then scroll
      setTimeout(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <>
      <footer className="bg-black text-white w-full mx-auto flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Logo and Description */}
            <div className="col-span-1 md:col-span-2">
              <Link to="/" className="flex items-center mb-4 hover:text-white">
                <img
                  src="/zstore_logo.png"
                  alt="Z-Store"
                  className="h-16 object-contain"
                />
                <span className="ml-2 text-2xl font-semibold">Z-Store</span>
              </Link>
              <p className="text-gray-200 mb-4 md:w-[60%]">
                Your one-stop shop for all your needs. We provide quality
                products with excellent customer service and fast delivery.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://facebook.com/ZagSystems"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="facebook"
                >
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                  </svg>
                </a>
                <a
                  href="https://x.com/ZagSystems"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="x"
                >
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill="currentColor"
                      d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"
                      strokeWidth={0.5}
                      stroke="currentColor"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/zagsystems21/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="instagram"
                >
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/zagsystems"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="linkedin"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={448}
                    height={512}
                    viewBox="0 0 448 512"
                    className="h-6 w-6"
                  >
                    <path
                      fill="currentColor"
                      d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3M135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5c0 21.3-17.2 38.5-38.5 38.5m282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7c-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5c67.2 0 79.7 44.3 79.7 101.9z"
                      strokeWidth={13}
                      stroke="currentColor"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@ZagSystems-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="youtube"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path
                      fill="currentColor"
                      fillRule="evenodd"
                      d="M9.935 14.628v-5.62l5.403 2.82zM21.8 8.035s-.195-1.379-.795-1.986c-.76-.796-1.613-.8-2.004-.847C16.203 5 12.004 5 12.004 5h-.008s-4.198 0-6.997.202c-.391.047-1.243.05-2.004.847c-.6.607-.795 1.986-.795 1.986S2 9.653 2 11.272v1.517c0 1.618.2 3.237.2 3.237s.195 1.378.795 1.985c.76.797 1.76.771 2.205.855c1.6.153 6.8.2 6.8.2s4.203-.006 7.001-.208c.391-.047 1.244-.05 2.004-.847c.6-.607.795-1.985.795-1.985s.2-1.619.2-3.237v-1.517c0-1.619-.2-3.237-.2-3.237"
                      strokeWidth={0.5}
                      stroke="currentColor"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://wa.me/+201505631036"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-200"
                  title="whatsapp"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path
                      fill="currentColor"
                      d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                      strokeWidth={0.5}
                      stroke="currentColor"
                    ></path>
                  </svg>
                </a>
              </div>

              <div className="flex flex-col md:flex-row gap-2 md:gap-0 md:space-x-4 mt-4">
                <a
                  href="https://apps.apple.com/eg/app/z-store/id6736878498"
                  target="_blank"
                  className="text-center py-2 px-3 rounded-xl text-white w-fit flex items-center justify-center gap-2 border border-white"
                >
                  <span className="border-[0.5px] border-[#ffffff9f] rounded-full p-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47c-1.34.03-1.77-.79-3.29-.79c-1.53 0-2 .77-3.27.82c-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51c1.28-.02 2.5.87 3.29.87c.78 0 2.26-1.07 3.81-.91c.65.03 2.47.26 3.64 1.98c-.09.06-2.17 1.28-2.15 3.81c.03 3.02 2.65 4.03 2.68 4.04c-.03.07-.42 1.44-1.38 2.83"
                      />
                      <path
                        fill="currentColor"
                        d="M13 3.5c.73-.83 1.94-1.46 2.94-1.5c.13 1.17-.34 2.35-1.04 3.19c-.69.85-1.83 1.51-2.95 1.42c-.15-1.15.41-2.35 1.05-3.11"
                      />
                    </svg>
                  </span>

                  <div className="flex flex-col items-start">
                    <span className="availableOn mr-1 text-[10px]">
                      Available on the
                    </span>
                    <span className="">Apple Store</span>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=org.zagsystems.z_store"
                  target="_blank"
                  className="text-center py-2 px-3 rounded-xl text-white w-fit flex items-center justify-center gap-2 border border-white"
                >
                  <span className="border-[0.5px] border-[#ffffff9f] rounded-full p-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      viewBox="0 0 240 283"
                    >
                      <path
                        fill="#ea4335"
                        d="M119.553 134.916L1.06 259.061a32.14 32.14 0 0 0 47.062 19.071l133.327-75.934z"
                        strokeWidth={7}
                        stroke="#ea4335"
                      ></path>
                      <path
                        fill="#fbbc04"
                        d="M239.37 113.814L181.715 80.79l-64.898 56.95l65.162 64.28l57.216-32.67a31.345 31.345 0 0 0 0-55.537z"
                        strokeWidth={7}
                        stroke="#fbbc04"
                      ></path>
                      <path
                        fill="#4285f4"
                        d="M1.06 23.487A30.6 30.6 0 0 0 0 31.61v219.327a32.3 32.3 0 0 0 1.06 8.124l122.555-120.966z"
                        strokeWidth={7}
                        stroke="#4285f4"
                      ></path>
                      <path
                        fill="#34a853"
                        d="m120.436 141.274l61.278-60.483L48.564 4.503A32.85 32.85 0 0 0 32.051 0C17.644-.028 4.978 9.534 1.06 23.399z"
                        strokeWidth={7}
                        stroke="#34a853"
                      ></path>
                    </svg>
                  </span>

                  <div className="flex flex-col items-start">
                    <span className="availableOn mr-1 text-[10px]">
                      Available on
                    </span>
                    <span className="">Google Play</span>
                  </div>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-span-1">
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("offers")}
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    Offers
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("categories")}
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    Categories
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("trending")}
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    Trending Products
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("products")}
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    All Products
                  </button>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-gray-200 hover:text-white cursor-pointer"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-200">
                  <a
                    href="https://www.google.com/maps?ll=30.595095,31.491212&z=15&t=m&hl=ar&gl=EG&mapclient=embed&cid=14770825894054451753"
                    target="_blank"
                    className="flex items-center text-gray-200 transition-colors hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={36}
                      height={36}
                      viewBox="0 0 32 32"
                      className="mr-3 h-12 w-14"
                    >
                      <path
                        fill="#fff"
                        d="M16 18a5 5 0 1 1 5-5a5.006 5.006 0 0 1-5 5m0-8a3 3 0 1 0 3 3a3.003 3.003 0 0 0-3-3"
                        strokeWidth={1}
                        stroke="#fff"
                      ></path>
                      <path
                        fill="#fff"
                        d="m16 30l-8.436-9.949a35 35 0 0 1-.348-.451A10.9 10.9 0 0 1 5 13a11 11 0 0 1 22 0a10.9 10.9 0 0 1-2.215 6.597l-.001.003s-.3.394-.345.447ZM8.813 18.395s.233.308.286.374L16 26.908l6.91-8.15c.044-.055.278-.365.279-.366A8.9 8.9 0 0 0 25 13a9 9 0 1 0-18 0a8.9 8.9 0 0 0 1.813 5.395"
                        strokeWidth={1}
                        stroke="#fff"
                      ></path>
                    </svg>
                    <span>
                      Elghasham Qawmiah, Tarek ibn Zeyad, Zagazig, Sharqia{" "}
                    </span>
                  </a>
                </li>
                <li className="flex items-center text-gray-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={36}
                    height={36}
                    viewBox="0 0 24 24"
                    className="mr-3 h-8 w-8"
                  >
                    <path
                      fill="#fff"
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4l-8 5l-8-5V6l8 5l8-5z"
                      strokeWidth={0.5}
                      stroke="#fff"
                    ></path>
                  </svg>
                  <a
                    href="mailto:sales@zagsystems.org"
                    target="_blank"
                    className="flex items-center text-gray-200 transition-colors hover:text-white"
                  >
                    sales@zagsystems.org
                  </a>
                </li>
                <li className="flex items-center text-gray-200">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={36}
                    height={36}
                    viewBox="0 0 24 24"
                    className="mr-3 h-8 w-8"
                  >
                    <path
                      fill="#fff"
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"
                      strokeWidth={0.5}
                      stroke="#fff"
                    ></path>
                  </svg>
                  <a
                    href="https://wa.me/+201505631036"
                    target="_blank"
                    className="flex items-center text-gray-200 transition-colors hover:text-white"
                  >
                    +20 150 563 1036
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="border-t border-[#ffffff70] py-1 text-center text-gray-700 bg-[#f0f0f0]">
        <p>&copy; {new Date().getFullYear()} Z-Store. All rights reserved.</p>
      </div>
    </>
  );
};

export default Footer;
